import React from "react"
import { useGetMedicalInfo, useMedicalInfo } from "../../context/MedicalInfoContext"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"
import { Form } from "@carrotfertility/carotene-core-x"
import {
  ButtonFooterLayout,
  ContinueButton,
  RoutingFlowTitle,
  SkipButton,
  StepLayout,
  useConvertTranslatedLabel
} from "#/components/carrot-plans/shared"
import { FormRadioButtonGroup } from "#/services/common-forms"

export default function PeriodsPainfulStep(): JSX.Element {
  const intl = useIntl()
  const { updateMedicalInfo, hasQuestionBeenSkipped } = useMedicalInfo()
  const { data: medicalInfo } = useGetMedicalInfo()
  const defaultValue = medicalInfo?.periodsPainful

  const { send } = useStateMachine(hasQuestionBeenSkipped("periodsPainful") ? "" : defaultValue)
  const buttonOptions = [
    { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
    { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
  ]
  const radioOptions = useConvertTranslatedLabel(buttonOptions)

  async function onClickContinue(formValues: { periodsPainful: string }): Promise<void> {
    if (formValues.periodsPainful !== null) {
      await updateMedicalInfo({ periodsPainful: formValues.periodsPainful })
      send(formValues.periodsPainful)
    } else {
      await onSkip()
    }
  }

  async function onSkip(): Promise<void> {
    await updateMedicalInfo({ skipFields: ["periodsPainful"] })
    send("")
  }

  const header = intl.formatMessage({
    defaultMessage: "Are your periods so painful that they make you miss work or activities?"
  })

  return (
    <>
      <RoutingFlowTitle title={header} />
      <StepLayout
        header={<span id="periodsPainful-label">{header}</span>}
        formElements={
          <Form onSubmit={onClickContinue} defaultValues={{ periodsPainful: defaultValue }}>
            <FormRadioButtonGroup name="periodsPainful" options={radioOptions} aria-labelledby="periodsPainful-label" />
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
              skipButton={<SkipButton onClick={onSkip} />}
            />
          </Form>
        }
      />
    </>
  )
}
